<template>
  <div v-if="props.page == 'home'">
    <div class="skeleton mb-4" style="height: 115px"></div>
    <div class="skeleton mb-4 mx-4" style="height: 200px"></div>
    <div class="d-flex justify-content-between gap-2 px-4 mb-1">
      <div class="skeleton mb-4" style="height: 70px; aspect-ratio: 1"></div>
      <div class="skeleton mb-4" style="height: 70px; aspect-ratio: 1"></div>
      <div class="skeleton mb-4" style="height: 70px; aspect-ratio: 1"></div>
      <div class="skeleton mb-4" style="height: 70px; aspect-ratio: 1"></div>
    </div>
    <div class="d-flex justify-content-between gap-2 mb-4 px-4">
      <div class="skeleton" style="height: 70px; aspect-ratio: 1"></div>
      <div class="skeleton" style="height: 70px; aspect-ratio: 1"></div>
      <div class="skeleton" style="height: 70px; aspect-ratio: 1"></div>
      <div class="skeleton" style="height: 70px; aspect-ratio: 1"></div>
    </div>
    <div class="skeleton mx-4" style="height: 170px"></div>
  </div>
  <div v-else-if="props.page == 'shops'">
    <div class="skeleton mb-2" style="height: 115px"></div>
    <div class="skeleton mb-4 mx-4" style="height: 25px"></div>
    <div class="skeleton mb-4 mx-4" style="height: 120px"></div>
    <div class="skeleton mb-4 mx-4" style="height: 40px"></div>
    <div class="skeleton mb-4 mx-4" style="height: 215px"></div>
    <div class="skeleton mb-4 mx-4" style="height: 215px"></div>
  </div>
  <div v-else-if="props.page == 'store'">
    <div class="skeleton mb-2" style="height: 115px"></div>
    <div class="skeleton mb-4 mx-4" style="height: 165px"></div>
    <div class="skeleton mb-4 mx-4" style="height: 215px"></div>
    <div class="d-flex justify-content-between gap-2 px-4 mb-1">
      <div class="skeleton mb-4" style="height: 70px; aspect-ratio: 1"></div>
      <div class="skeleton mb-4" style="height: 70px; aspect-ratio: 1"></div>
      <div class="skeleton mb-4" style="height: 70px; aspect-ratio: 1"></div>
      <div class="skeleton mb-4" style="height: 70px; aspect-ratio: 1"></div>
    </div>
    <div class="d-flex justify-content-between gap-2 px-4 mb-1">
      <div class="skeleton mb-4" style="height: 70px; aspect-ratio: 1"></div>
      <div class="skeleton mb-4" style="height: 70px; aspect-ratio: 1"></div>
      <div class="skeleton mb-4" style="height: 70px; aspect-ratio: 1"></div>
      <div class="skeleton mb-4" style="height: 70px; aspect-ratio: 1"></div>
    </div>
    <div class="skeleton mb-4 mx-4" style="height: 215px"></div>
  </div>
  <div v-else-if="props.page == 'product'">
    <div class="skeleton mb-2" style="height: 115px"></div>
    <div class="skeleton mb-4 mx-4" style="height: 25px"></div>
    <div class="skeleton mb-4 mx-4" style="height: 415px"></div>
    <div class="skeleton mb-2 mx-4" style="height: 25px;width:250px"></div>
    <div class="skeleton mb-2 mx-4" style="height: 25px;width:150px"></div>
    <div class="skeleton mb-5 mx-4" style="height: 25px;width:150px"></div>
    <div class="skeleton mb-2 mx-4" style="height: 425px;"></div>
  </div>
  <div v-else-if="props.page == 'ordination'">
    <div class="skeleton my-4 mx-2" style="height: 25px"></div>
    <div class="skeleton mb-4 mx-2" style="height: 115px"></div>
    <div class="d-flex justify-content-between mb-3">
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
    </div>
    <div class="d-flex justify-content-between mb-3">
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
    </div>
    <div class="d-flex justify-content-between mb-3">
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
    </div>
  </div>
  <div v-else-if="props.page == 'group'">
    <div class="skeleton my-4 mx-2" style="height: 25px"></div>
    <div class="d-flex justify-content-between mb-3">
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
    </div>
    <div class="d-flex justify-content-between mb-3">
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
    </div>
    <div class="d-flex justify-content-between mb-3">
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
    </div>
    <div class="d-flex justify-content-between mb-3">
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
      <div class="skeleton" style="width:30%;max-width:200px;aspect-ratio: 1;"></div>
    </div>
  </div>
</template>
<script setup>
import { defineProps } from "vue";
const props = defineProps(["page"]);
</script>
<style scoped>
.skeleton {
  background-color: #e2e5e7;
  border-radius: 0.5em;
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 0)
  );
  background-size: 40px 100%;
  background-repeat: no-repeat;
  background-position: left -40px top 0;
  -webkit-animation: shine 1s ease infinite;
  animation: shine 1s ease infinite;
}

@-webkit-keyframes shine {
  to {
    background-position: right -40px top 0;
  }
}

@keyframes shine {
  to {
    background-position: right -40px top 0;
  }
}
</style>
